// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__Ogao3","paramInput":"JobSimulator_paramInput__c_iDw","input":"JobSimulator_input__az9l8"};